<template>
  <div class="questions">
    <GoBack v-if="currentQuestion.number !== 'one'"
            currentScreen="questions" 
            @resetActiveItem = "resetActiveItem" />

    <div class="questions__number"> Question {{currentQuestion.number}}</div>

    <!-- fade in/out title -->
    <transition name="slide-fade" mode="out-in">
      <h1 :key="currentQuestion.title">{{ currentQuestion.title }}</h1>
    </transition>

    <!-- fade in/out questions items -->
    <transition name="fade" mode="out-in">
      <div class="questions__items" :key="currentQuestion.number">

        <div v-for="(colour, i) in currentQuestionColours" 
            :key="colour.red + colour.green + colour.blue + i"
            :class="['questions__item', currentQuestion.number, 
                    { 'active': i === activeItem, 
                      'disabled': i !== activeItem && activeItem !== null,
                      'no-name': !colour.name
                    }]"
            v-on:click="selectColour(i)">

          <div class="item__circle"
                v-bind:style="[{'backgroundColor': 'rgb('+ colour.red + ',' + colour.green + ',' + colour.blue + ')'}, 
                              colour.image ? {'backgroundImage': 'url(' + require('@/assets/img/' + colour.image) + ')' } : null]">
          </div>

          <p>{{getColourLabel(colour, i, currentQuestionColours.length)}}</p>
        </div>
      </div>
    </transition>
    <NextButton :activeItem="activeItem" :selectedColor="selectColour" :currentQuestion="currentQuestion" @animated-click="next" />
  </div>
</template>

<script>
import { upperFirst } from 'lodash'
import { event } from 'vue-analytics'
import { question2, question3Colour } from '../assets/data/data'
import questionsJourneyLarge from '../assets/data/questionsJourney.json'
import questionsJourneySmall from '../assets/data/questionsJourneySmall.json'
import GoBack from './elements/GoBack.vue'
import NextButton from './elements/NextButton'

export default {
  name: 'Questions',
  components: {
    GoBack,
    NextButton
  },

  data() {
    return {
      activeItem: null
    }
  },
  computed: {
    currentQuestion: function() {
      return this.$store.state.currentQuestion;
    },
    currentQuestionColours() {
      return this.currentQuestion.colours;
    },
    currentPattern : function() {
      return this.$store.state.currentPattern;
    },
    selectedColor : function() {
      return this.$store.state.selectedColor;
    },
    interiorOrExterior() {
      return this.$store.state.interiorOrExterior;
    },
    lastQuestion: function() {
      return this.$store.state.lastQuestion;
    },
    wallType () {
      return this.$route.query.wall || 'large'
    },
    questionsJourney () {
      return this.wallType === 'small' ? questionsJourneySmall : questionsJourneyLarge
    }
  },
  mounted() {
    this.$store.commit('updateSelectedColor', this.currentQuestion.color)
    this.$store.commit('updateBg', [this.currentQuestion.color.red, this.currentQuestion.color.green, this.currentQuestion.color.blue])
    this.activeItem = null
	},
  methods: {
    resetActiveItem() {
      this.activeItem = null;
    },
    selectColour(i){
      this.activeItem = i
      if (this.currentQuestion.number === 'one' ) {
        this.$store.commit('setInteriorExterior', this.currentQuestion.colours[i].name) //setup interior/exterior for link on Results page
      } else {
        this.$store.commit('updateSelectedColor', this.currentQuestion.colours[i])

        if (this.currentQuestion.number === 'two') { //question 2 changes background color
          this.$store.commit('updateBg', [this.currentQuestion.colours[i].red, this.currentQuestion.colours[i].green, this.currentQuestion.colours[i].blue])
          this.$store.commit('updatePattern', this.currentQuestion.colours[i].name) //update pattern Whites/Colours/Neutrals/Greys
        }

        if (this.currentQuestion.colours[i].mainTitle) { //if the color selected change the title
          var copyQuestion = JSON.parse(JSON.stringify(this.currentQuestion))
          copyQuestion.title = this.currentQuestion.colours[i].mainTitle
          this.$store.commit('updateCurrentQuestion', copyQuestion)
        }
      }
    },
    getColourLabel(colour, index, total) {
      if (index == 0 || index == total - 1) {
        if ((this.currentPattern === 'Whites' || this.currentPattern === 'Greys') && this.currentQuestion.number === 'three') {
          return (colour.type === 'cool' || colour.type === 'light') ? 'Cooler' : 'Warmer'
        } else if ((this.currentPattern === 'Colours' && this.currentQuestion.number === 'four') ||
            (this.currentPattern !== 'Colours' && this.currentQuestion.number === 'three')) {
          return colour.type === 'dark' ? 'Darker' : 'Lighter'
        }
      }
      return colour.name ? colour.name : null;
    },
    next() {
      if (this.lastQuestion) { // if it's the last question, generate results list, update selected color, reset question and go to mixing
        event(upperFirst(this.interiorOrExterior), upperFirst(this.currentPattern), this.selectedColor?.colourName)

        this.$store.commit('updateResultsList', this.currentQuestion.colours[this.activeItem].colours)
        this.$store.commit('updateResultsListPrimaryColor', this.currentQuestion.colours[this.activeItem])
        this.$store.commit('updateSelectedColor', this.currentQuestion.colours[this.activeItem])
        // 
        this.$store.commit('isLastQuestion', false)
        this.$router.push('mixing')
      } else {
        switch (this.currentQuestion.number) {
          case "one":
            event('Interior', 'Click')
            break;
          case "two":
            event(upperFirst(this.currentPattern), 'Click')
            break;
          case "three":
            event(upperFirst(this.interiorOrExterior), upperFirst(this.currentPattern), this.selectedColor?.colourName)
            break;
          default:
            break;
        }
        //special question one
        if (this.currentQuestion.number === "one") {
          this.questionOne()
          
        } else {
          switch (this.currentPattern) {
            case 'Whites':
              this.whitePath();
              break;
            case 'Greys':
              this.greyPath();
              break;
            case 'Neutrals':
              this.neutralPath();
              break;
            case 'Colours':
              this.colorPath();
              break;
            default:
              break;
          }
        }
        this.$store.commit('updateSelectedColor', this.currentQuestion.color)
        this.$store.commit('updateBg', [this.currentQuestion.color.red, this.currentQuestion.color.green, this.currentQuestion.color.blue])

        this.resetActiveItem() //unselect item
      }
    },
    questionOne() {
      this.$store.commit('updateCurrentQuestion', question2)
    },
    colorPath() {
      if (this.currentQuestion.number === 'two') {
        this.$store.commit('updateCurrentQuestion', question3Colour)
      } else {
        this.commonPath()
        this.$store.commit('isLastQuestion', true)
      }
    },
    whitePath() {
      this.commonPath()
      this.$store.commit('isLastQuestion', true)
    },
    greyPath(){
      if(this.currentQuestion.number === 'two') {
        this.commonPath()
        if (this.wallType === 'small') {
          this.$store.commit('isLastQuestion', true)
        }
      } else {
        this.greyNeutralSecondPath()
      }
    },
    neutralPath(){
      if(this.currentQuestion.number === 'two') {
        this.commonPath()
      } else {
        this.greyNeutralSecondPath()
      }
    },
    commonPath() {
      var copyQuestion = JSON.parse(JSON.stringify(this.currentQuestion))
      var currentJourney = ''

      for (var i = 0; i < this.questionsJourney.length; i ++) {
        if (this.questionsJourney[i].name == this.selectedColor.category) {
          currentJourney = this.questionsJourney[i].colours
        }
      }
      
      copyQuestion.title = this.selectedColor.type === 'light' ? 
        `Are you looking for darker or lighter ${this.selectedColor.category}?`:
        `Are you looking for warmer or cooler ${this.selectedColor.category}?`
      copyQuestion.number === 'two' ? copyQuestion.number = "three": copyQuestion.number = "four"
      copyQuestion.colours = currentJourney

      this.$store.commit('updateCurrentQuestion', copyQuestion)
    },
    greyNeutralSecondPath() {
      var copyQuestion = JSON.parse(JSON.stringify(this.currentQuestion))
      copyQuestion.title = 'Do you prefer the two on the left or on the right?'
      copyQuestion.number = "four"
      copyQuestion.colours = this.currentQuestion.colours[this.activeItem].colours
      this.$store.commit('updateCurrentQuestion', copyQuestion)
      this.$store.commit('isLastQuestion', true)
    },
  },
}
</script>
